<template>
  <section class="content" id="marketplace">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          <i class="fa fa-wrench mr-5"></i>
          {{ 'shipping-config' | translate }}
        </h3>
      </div>
    </div>
    <div class="box-body">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>#</th>
            <th>{{"marketplace" | translate}}</th>
            <th>{{"freeShippingFrom" | translate}}</th>
            <th>{{"shipping" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="marketplace in marketplaceData">
            <td>{{marketplace.marketplaceId}}</td>
            <td>{{marketplace.label}}</td>
            <td><span v-if="marketplace.freeShippingFrom">{{marketplace.freeShippingFrom | currency}}</span></td>
            <td><span v-if="marketplace.shipping">{{marketplace.shipping | currency}}</span></td>
            <td>
              <button
                class="btn btn-flat btn-info mb-10 mt-10"
                data-toggle="modal"
                data-target="#shippingConfigModal"
                @click="openShippingConfigModal(marketplace)">
                <i class="fa fa-wrench mr-5"></i>
                {{'edit'|translate}}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ShippingConfigModal id="shippingConfigModal" :model="model" :modelRefresh="modelRefresh"></ShippingConfigModal>
  </section>
</template>

<script>
export default {
  data() {
    return {
      marketplaceData: [],
      modelRefresh: {},
      model: {
        label: '',
        marketplaceId: 0,
        merchantId: 0,
        shipping: 0,
        freeShippingFrom: 0,
        maxShippingCost: 0
      }
    }
  },
  methods: {
    openShippingConfigModal(marketplace) {
      this.modelRefresh = marketplace
      this.model = JSON.parse(JSON.stringify(marketplace))
    }
  },
  computed: {},
  mounted() {
    API.get('uvp/shipping')
      .then(res => {
        this.marketplaceData = res.data
      })
  }
}
</script>

<style>
#marketplace .btn {
  float: right;
}

#marketplace th {
  width: 20rem;
}

.overlay {
  z-index: 50;
  background: rgba(33, 34, 40, .75);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 110%;
}

.overlay > .fa {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -1rem;
  margin-top: -1rem;
  color: currentColor;
  font-size: 2rem;
  opacity: 0.65;
}

.min-width-45 {
  min-width: 45%;
}
</style>
<style scoped>
.loading-gif {
  display: block;
  width: 5%;
  top: 42%;
  left: 50%;
  position: fixed;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Settings/ShippinCost.vue